import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function LoginPage({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

 const handleSubmit = async (e) => {
   e.preventDefault();
   setIsLoading(true);

   try {
     const response = await axios.post(`${API}/auth/login`, {
       email,
       password,
     });

     const data = response.data;

     if (data.success) {
       toast.success("Login successful!");

       // Save token and user in local storage
       
       const comment = data?.data?.comment;
       onLogin(data.data.token, data.data.user,comment);
       
      //  // Redirect after saving login info
      //  if (comment === "new_user") {
      //    window.location.href = "https://google.com";
      //  } else {
      //    window.location.href = "/dashboard";
      //  }
     } else {
       toast.error(data.message || "Login failed");
     }
   } catch (error) {
     toast.error("An error occurred during login");
     console.error("Login error:", error);
   } finally {
     setIsLoading(false);
   }
 };
  
  const handleForgotPassword = () => {
    // Option 1: navigate to reset password page
    navigate("/reset-password");
    // console.log("forgot")
    // Option 2: open modal
    // setShowResetModal(true);
  };



 return (
   <div className="login-container" data-testid="login-page">
     <div className="login-card">
       <div className="login-header">
         <h1 data-testid="login-title">Leave Tracker</h1>
         <p data-testid="login-subtitle">Culinary Compass Employee Portal</p>
       </div>

       <form onSubmit={handleSubmit} data-testid="login-form">
         <div className="form-group">
           <label htmlFor="email">Email Address</label>
           <input
             type="email"
             id="email"
             data-testid="email-input"
             value={email}
             onChange={(e) => setEmail(e.target.value)}
             placeholder="your.name@culinarycompass.in"
             required
           />
         </div>

         <div className="form-group">
           <label htmlFor="password">Password</label>
           <input
             type="password"
             id="password"
             data-testid="password-input"
             value={password}
             onChange={(e) => setPassword(e.target.value)}
             placeholder="Enter your password"
             required
           />
         </div>

         <button
           type="submit"
           className="login-btn"
           data-testid="login-submit-btn"
           disabled={isLoading}
         >
           {isLoading ? "Signing in..." : "Sign In"}
         </button>

         {/* Reset Password Button */}
         <button
           type="button"
           className="reset-password-btn"
           onClick={handleForgotPassword}
           style={{
             background: "none",
             border: "none",
             color: "#2563eb",
             fontSize: "0.9rem",
             marginTop: "0.75rem",
             textDecoration: "underline",
             cursor: "pointer",
           }}
         >
           Forgot Password?
         </button>
       </form>

       {/* Demo Account (optional)
      <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#edf2f7', borderRadius: '0.5rem', fontSize: '0.85rem' }}>
        <strong>Demo Account:</strong>
        <br />
        Email: make@culinarycompass.in
        <br />
        Password: admin123
      </div> */}
     </div>
   </div>
 );

}

export default LoginPage;